import $ from 'jquery';
import 'slick-carousel';

const settings = {
  dots: true,
  arrows: false,
  slidesToShow: 4,
  slidesToScroll: 4,
  infinite: false,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
      },
    },
  ],
};

export default class HomepageEvents {
  constructor(element) {
    this.slider = $(element).find('.events').slick(settings);
  }
}
